/*
 *  -----------------------------------------------------------------------
 *    <copyright file="grid.ts" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import { RefObject } from 'react';
import Constants from '@utils/constants';
import { MOVEMENT_STATE } from '@utils/risk.service';
import { isStringNumeric } from '@utils/validation';
import { FieldDefinitionFieldType } from '@types/graphql-global-types';

// convert dates in compatible format for grouping, to group just dates without time or to group dates with partial dates
// returns a new settings for grouping and modified array to group

export const updateGridDetailsWidth = () => {
    const detailsItems = document.querySelectorAll('.child-details-grid-wrapper > .child-details-grid .k-detail-cell');
    if (detailsItems.length) {
        const gridWidth = document
            .querySelector('.child-details-grid-wrapper > .child-details-grid')
            ?.getBoundingClientRect().width;
        detailsItems.forEach((item) => {
            item.style.width = `${gridWidth}px`;
        });
    }
};

export const getCellNumberFromString = (value: null | string, type?: string | null, isAbs?: boolean) => {
    if (value === null) return null;

    const numberValue = Number(value);

    if (isNaN(numberValue) || !type) return value;

    if (type === Constants.FieldDefinitionFieldTextTypes.int) {
        return Number(isAbs ? Math.abs(numberValue) : numberValue);
    }
    if (type === Constants.FieldDefinitionFieldTextTypes.float) {
        return Number((isAbs ? Math.abs(numberValue) : numberValue).toFixed(2));
    }

    return numberValue;
};

export const getChangeMovement = (
    prev: null | string,
    current: null | string,
    change: null | string,
    type?: FieldDefinitionFieldType | null | undefined,
) => {
    const prevNew = getCellNumberFromString(prev, type);
    const currentNew = getCellNumberFromString(current, type);
    const changeNew =
        isStringNumeric(prevNew) && isStringNumeric(currentNew) ? getCellNumberFromString(change, type) : null;

    return {
        change:
            Number(prevNew) > Number(currentNew)
                ? MOVEMENT_STATE.falling
                : Number(prevNew) < Number(currentNew)
                ? MOVEMENT_STATE.rising
                : '',
        score: changeNew !== null && !isNaN(changeNew) ? Math.abs(changeNew).toFixed(2) : null,
    };
};

export const gridsHeightCalculating = (
    ref: RefObject<any>,
    gridsCount: number,
    correctedValue: number,
    paddingBtwnGrids: number,
) => {
    const gridsWrapHeight = ref.current?.clientHeight;
    const gridHeight = (gridsWrapHeight - paddingBtwnGrids) / gridsCount;
    const grids = document.getElementsByClassName('k-grid-content');

    for (let i = 0; i < grids.length; i++) {
        grids[i].style.maxHeight = `${gridHeight - correctedValue}px`;
    }
};
